"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonProps = exports.getProps = void 0;

var _router = require("@reach/router");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _getProps = function getProps(_ref) {
  var isCurrent = _ref.isCurrent,
      isPartiallyCurrent = _ref.isPartiallyCurrent;
  var styleProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isCurrent || isPartiallyCurrent) return {
    style: _objectSpread({
      textDecoration: 'underline'
    }, styleProps)
  };
  return {};
};

exports.getProps = _getProps;

var getButtonProps = function getButtonProps(item, styleProps) {
  return item.href ? {
    component: _router.Link,
    to: item.href,
    getProps: function getProps(args) {
      return _getProps(args, styleProps);
    }
  } : {
    disableRipple: true,
    style: {
      cursor: 'not-allowed'
    }
  };
};

exports.getButtonProps = getButtonProps;